import dayjs from 'dayjs';

const getWeekOfYear = (date: Date) => {
  const startOfYear = dayjs(date).startOf('year');
  const dayOfYear = dayjs(date).diff(startOfYear, 'day') + 1;
  return Math.ceil(dayOfYear / 7);
};

export const formatWeekOfYear = (date: Date) => {
  const weekNumber = getWeekOfYear(date);
  const year = dayjs(date).year();
  return `Week ${String(weekNumber).padStart(2, '0')}/${year}`;
};

export const getLocalISODateString = (dateStr: Date | string | undefined) => {
  if (dateStr) {
    const date = new Date(dateStr);
    const timezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - timezoneOffset).toISOString();
  }
  return undefined;
};

export const formatDate = (date: Date, format: string) => {
  return dayjs(date).format(format);
};

// Relative time ("3 days ago") for comments/activity. Requires the dayjs
// relativeTime plugin, registered once in main.tsx.
export const formatRelativeTime = (date: Date | string) => {
  return dayjs(date).fromNow();
};

export const COMMENT_TIMESTAMP_FORMAT = 'MMM DD, YYYY, HH:mm';
